import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidennav from "./sidenavbar";
import Topnavbar from "./topnavbar";
import "./dashboard.css";

export default function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    window.innerWidth >= 1024
  );

  // Handle window resize with debounce to avoid ResizeObserver errors
  useEffect(() => {
    let timeoutId = null;

    const handleResize = () => {
      // Clear existing timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Debounce resize handler
      timeoutId = setTimeout(() => {
        const shouldBeOpen = window.innerWidth >= 1024;
        setIsSidebarOpen(shouldBeOpen);
      }, 150); // 150ms debounce
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close sidebar when clicking outside on mobile
  const handleOverlayClick = () => {
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className={`dashboard-layout ${isSidebarOpen ? "" : "sidebar-collapsed"}`}>
      <Sidennav isOpen={isSidebarOpen} onCloseSidebar={() => setIsSidebarOpen(false)} />

      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={handleOverlayClick} />
      )}

      <div className="main-wrapper">
        <Topnavbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}